export default {"src":"/_next/static/media/favicon.f7481c69.ico","height":48,"width":48,"blurWidth":0,"blurHeight":0};